import React, { useState } from "react";
import { useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../Services/ApiService"; 
import { 
  showErrorAlert,
  showSuccessAlert,
} from "../../Helper/SweetAlert";
import video from "../../assets/img/video.mp4";

export default function ResetPassword() {
    const { token } = useParams();

    let navigate = useNavigate();

    const [newPassword, setnewPassword] = useState(""); 
    const [confirmPassword, setconfirmPassword] = useState(""); 
    const [error, setError] = useState(false);
  
    const [submitLoader, setsubmitLoader] = useState(false);
  
 
  
    const submitForm = async (e) => {
        console.log(token)
      e.preventDefault();
      if (!newPassword || !confirmPassword) {
        setError(true);
        return;
      }
      if(confirmPassword !== newPassword){return}

      const data = {
        password:newPassword,
        token: token
      }
      setsubmitLoader(true);
      await axios.post(API_URL.RESET_Password,data).then(
        (res) => {
          console.log(res);
          if (res?.data?.status === true) {
            showSuccessAlert(res?.data?.message, ()=>{
              navigate("/login");
            }); 
          } else {
            showErrorAlert(res.data?.message); 
          }
          setsubmitLoader(false);
          setError(false);
        },
        (err) => {
          // console.log(err?.response?.data);
          setsubmitLoader(false);
          setError(false);
          showErrorAlert(err?.response?.data?.message); 
        }
      );
    };

  return (
    <div>
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
        <div className="background-video">
            <video autoPlay loop muted>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div
                className="auth-form-light text-center py-5 px-4 px-sm-5"
                style={{ borderRadius: "25px" }}
              >
                <div className="brand-logo">
                  <img src="../../images/logo.png" alt="logo" />
                </div>
                <h4>Reset Your Password</h4>
                <form
                  className="pt-3"
                  onSubmit={(e) => {
                    submitForm(e);
                  }}
                > 
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg" 
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setnewPassword(e.target.value)}
                      />
                   {error && !newPassword &&(
                    <div className="error mt-1">New Password is required</div>
                   )}
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-lg" 
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setconfirmPassword(e.target.value)}
                      />
                   {error && !confirmPassword &&(
                    <div className="error mt-1">Confirm Password is required</div>
                   )}
                   {confirmPassword && (confirmPassword !== newPassword) &&(
                    <div className="error mt-1">Password Mismatch! Recheck</div>
                   )}
                    </div> 

                  <div className="mt-3"> 
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={submitLoader}
                    >
                      {submitLoader ? (
                        <i className="fas fa-spinner fa-spin"></i>
                      ) : (
                        "Submit"
                      )}
                    </button> 
                  </div> 
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
